
import React, { useEffect } from "react";
import { BiMoon, BiSun } from "react-icons/bi";

const Navbar1 = (props) => {
      useEffect(() => {
        const navbar = document.body.querySelector(".navbar");

        navbar.style.backgroundColor = " white";
      }, []);

      let mode = props.mode;
      let setMode = props.setMode;
      function handler() {
        const Mode = document.body;
        const navbar = document.body.querySelector(".navbar");
        const bg1 = document.body.querySelector(".fotter");

        if (mode === true) {
          setMode(false);
          Mode.classList.remove("bright-mode");
          Mode.classList.add("dark-mode");
          navbar.style.backgroundColor = "#191627";
          bg1.style.backgroundColor = " rgb(1 2 20)";
        } else {
          setMode(true);
          Mode.classList.remove("dark-mode");
          Mode.classList.add("bright-mode");
          navbar.style.backgroundColor = " white";
          bg1.style.backgroundColor = "#6E57E0";
        }
      }

  
  return (
    <div className="   mx-auto items-center font-Poppins  w-full top-0  z-[100] border-10 border-black bg-back navbar ">
      <div className="  md:hidden mt-3 flex flex-row justify-around items-center mx-auto ">
        <div className=" hover:text-deep items-center text-center">
          <a href="#">Tanmay | Web Developer</a>
        </div>
        <div className="">
          <div className=" mt-0.5 hover:cursor-pointer hover:text-deep font-bold ">
            {mode ? (
              <span onClick={handler}>
                {" "}
                <BiMoon fontSize={20} />
              </span>
            ) : (
              <span onClick={handler}>
                {" "}
                <BiSun fontSize={20} />
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Navbar1